var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-page",class:_vm.classTitle},[_c('h4',[_vm._v(_vm._s(_vm.attrpage))]),_c('h1',[_vm._t("default"),_c('br'),_c('span',[_vm._v(_vm._s(_vm.baseline))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }